import React, { useEffect, useRef, useState, useContext } from "react";
import './Registration_form.css'
import Form from 'react-bootstrap/Form';
import Select from "react-select";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import RegisterModal from '../../common-section/Modals/RegisterModal/RegisterModal';
import { CareerResgistrationForm } from '../../../utils/apis/form/form';
import { Context } from "../../../utils/context";
import { RegxExpression } from "../../../utils/common";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { getData, postData } from "../../../utils/api";
import { useNavigate } from "react-router-dom";
import { Experience } from "../../../utils/apis/master/Master";


const Registration_form = (props) => {

    const { jobId } = useContext(Context)
    const [selectedOption, setSelectedOption] = useState(null);


    const navigate = useNavigate()

    const [modalShow, setModalShow] = useState(false);

    const [value, setValue] = useState();


    const { postData, getData, Select2Data } = useContext(Context);
    const [experience, setExperience] = useState([]);

    console.log("jobId", jobId)

    const {
        control,
        register,
        handleSubmit,
        getValues,
        setError,
        clearErrors,
        formState: { errors },
        reset,
        trigger,
    } = useForm();


    const onSubmit = async (data) => {


        try {
            const formData = new FormData();
            formData.append("email", data?.email);
            formData.append("first_name", data?.first_name);
            formData.append("last_name", data?.last_name);
            formData.append("address", data?.address);
            formData.append("mobile_no", data?.mobile_no);
            formData.append("job_id", jobId);
            formData.append("experience_id", data?.experience_id);
            if (data?.resume && data?.resume?.length > 0) {
                formData.append("resume", data.resume[0]);
            }

            console.log("CareerResgistrationForm", data)

         

            const res = await CareerResgistrationForm(formData);

            if (res?.success) {
                // Show success modal
                setModalShow(true);

                // Hide modal after 3 seconds
                setTimeout(() => {
                    setModalShow(false);
                    // Optional: Reset form fields
                    reset();
                    // Optional: Close the parent modal
                    if (props.onHide) props.onHide();
                    navigate("/")
                }, 3000);



            } else {
                // Handle error response
                console.error("Error response:", res);
                // Optionally, show error feedback to the user
            }
        } catch (error) {
            console.error("Submission error:", error);
            // Optionally, show error feedback to the user
        }
    };



    const [experienceData, setExperienceData] = useState([]);

    console.log("experienceData", experienceData)


    const getExperience = async () => {
        const res = await Experience()
        if (res?.success) {

            const sorteddata = res?.data?.sort((a,b) => a?.experience_from - b?.experience_from)

            const data = sorteddata.map((data) => ({
                value: data?.id,
                label: data?.name,
                name: "experience_id",
              }));
            

            console.log("getExperience",data)

            

            setExperienceData(data)
        }
    }

    useEffect(() => {
        getExperience()
    }, [])


    return (
        <>
            <section className=' container'>
                <div className='Registration_form'>
                    <div className='text-center'>
                        <h1 className='fadetext'>Post Your Resume / Registration</h1>
                        <h6 className='posttt'>Post Your Resume / Registration</h6>
                    </div>

                    <div className='row'>
                        <div className='col-lg-10 mx-auto'>
                            <div className='form-sec'>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <div className='row'>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>First Name*</Form.Label>
                                                <Form.Control
                                                    className={classNames("", {
                                                        "is-invalid": errors?.first_name,
                                                    })}
                                                    type="text" name="first_name" placeholder="Enter First Name"

                                                    {...register("first_name", {
                                                        required: "Name is required",
                                                        pattern: {
                                                            value: /^[A-Za-z ]*$/,
                                                            message: "Name must contain only letters",
                                                        },
                                                    })}
                                                    onKeyDown={(event) => {
                                                        if (!/[A-Z-a-z ]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {errors?.first_name && (
                                                    <span className="text-danger">
                                                        {errors?.first_name?.message}
                                                    </span>
                                                )}

                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>Last Name*</Form.Label>
                                                <Form.Control
                                                    className={classNames("", {
                                                        "is-invalid": errors?.last_name,
                                                    })}
                                                    type="text" name="last_name" placeholder="Enter Last Name"
                                                    {...register("last_name", {
                                                        required: "Last Name is required",
                                                        pattern: {
                                                            value: /^[A-Za-z ]*$/,
                                                            message: "Last Name must contain only letters",
                                                        },
                                                    })}
                                                    onKeyDown={(event) => {
                                                        if (!/[A-Z-a-z ]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {errors?.last_name && (
                                                    <span className="text-danger">
                                                        {errors?.last_name?.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>Email*</Form.Label>
                                                <Form.Control
                                                    className={classNames("", {
                                                        "is-invalid": errors?.email,
                                                    })}
                                                    type="email" name="email" placeholder="Enter Email"
                                                    {...register("email", {
                                                        required: "E-mail is required",
                                                        pattern: {
                                                            value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z]{2,4})\.\2)([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                                                            message: "Invalid E-Mail Address",
                                                        },
                                                    })}
                                                />

                                                {errors?.email && (
                                                    <span className="text-danger">
                                                        {errors?.email?.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>Address*</Form.Label>
                                                <Form.Control
                                                    className={classNames("", {
                                                        "is-invalid": errors?.address,
                                                    })}
                                                    type="text" name="address" placeholder="Enter Address"
                                                    {...register("address", {
                                                        required: "Address is required",
                                                        pattern: {
                                                            // value: /^[A-Za-z ]*$/,
                                                            message: "",
                                                        },
                                                    })}
                                                    // onKeyDown={(event) => {
                                                    //     if (!/[A-Z-a-z ]/.test(event.key)) {
                                                    //         event.preventDefault();
                                                    //     }
                                                    // }}
                                                />


                                                {errors?.address && (
                                                    <span className="text-danger">
                                                        {errors?.address?.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            {/* <div className='form-group'>
                                                <Form.Label>Mobile Number*</Form.Label>
                                                <PhoneInput
                                                    country={'in'}
                                                    name="mobile_no"
                                                />
                                            </div> */}
                                            <div className="form-group">
                                                <Form.Label>Mobile Number*</Form.Label>
                                                <Controller
                                                    country={'in'}
                                                    className={classNames("", {
                                                        "is-invalid": errors?.mobile_no,
                                                    })}
                                                    name="mobile_no"
                                                    control={control}
                                                    rules={{
                                                        required: "Mobile Number is required",
                                                        minLength: {
                                                            value: 12,
                                                            message: "Number should be at least 10 characters",
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <PhoneInput
                                                            {...field}
                                                            className={classNames("", {
                                                                "is-invalid": errors?.mobile_no,
                                                            })}
                                                            onChange={(value) => field.onChange(value)}
                                                            type="text"
                                                            placeholder="Enter Mobile Number"
                                                            country={'in'}
                                                            onKeyDown={(event) => {
                                                                if (!RegxExpression.phone?.test(event.key)) {
                                                                    if (event.key !== "Backspace") {
                                                                        event.preventDefault();
                                                                    }
                                                                }
                                                            }}
                                                            maxLength={10}
                                                        />
                                                    )}
                                                />
                                                {errors?.mobile_no && (
                                                    <span className="text-danger">
                                                        {errors?.mobile_no?.message}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>Experience*</Form.Label>

                                                <Controller
                                                    name="experience_id"
                                                    control={control}
                                                    rules={{ required: "Experience is required" }}
                                                    render={({ field, fieldState }) => (
                                                        <Select
                                                            {...field}
                                                            value={experienceData.find((option) => option.value === field.value)} // Match current value
                                                            onChange={(selectedOption) => {
                                                                console.log("selectedOption", selectedOption);
                                                                field.onChange(selectedOption?.value); // Update the Controller's value
                                                            }}
                                                            classNamePrefix="buisness"
                                                            options={experienceData}
                                                            placeholder="Select Experience"
                                                            className={classNames("", { "is-invalid": fieldState.error })}
                                                        />
                                                    )}
                                                />
                                                {errors.experience_id && (
                                                    <span className="text-danger">
                                                        {errors.experience_id?.message}
                                                    </span>
                                                )}

                                                {/* <Form.Select aria-label="Default select example"

                                                    className={classNames("", { "is-invalid": errors?.experience_id })}
                                                    {...register("experience_id", { required: "Please select Experience" })}
                                                >
                                                    <option>Select Experience</option>
                                                    
                                                </Form.Select>
                                                 */}
                                            </div>
                                        </div>
                                        <div className='col-md-6 mb-3'>
                                            <div className='form-group'>
                                                <Form.Label>Upload Resume*</Form.Label>
                                                <Form.Control type="file"

                                                    className={classNames("", {
                                                        "is-invalid": errors?.resume,
                                                    })}
                                                    {...register("resume",
                                                        { required: "Please Upload a Resume" })}
                                                    accept=".doc,.docx,.rtf,.pdf" />
                                                <span className='smalltetx' >Upload Your Resume* (upload only .doc, .docx , .rtf , .pdf files)</span>
                                            </div>
                                            {errors.resume && (
                                                <span className="text-danger">
                                                    {errors.resume?.message}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className='text-center'>
                                        <button className='submitbtn'
                                            // type='button'
                                            type="submit"
                                        //  onClick={() => setModalShow(true)}

                                        >Submit</button>
                                    </div>
                                </Form >
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <RegisterModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                message="Your Resume / Registration has been Submitted Successfully"
            />


        </>
    )
}

export default Registration_form